export default __webpack_public_path__ + "static/media/hero.6576b48d.png";